// dom READY
document.addEventListener('DOMContentLoaded', () => {
  const inputs = document.querySelectorAll('.cart_note');
  inputs.forEach((input) => {
    input.addEventListener('input', () => {
      const value = input.value;
      inputs.forEach((otherInput) => {
        if (otherInput !== input) {
          otherInput.value = value;
        }
      });
    });
  });
});
